export default "__VITE_ASSET__C2TI6IGa__"